export const ONLINE_PGP_ROLES = {
  pm: 'Product / Program / Project Manager',
  finance: 'Finance / Business Analyst',
  sales: 'Sales / Growth / Revenue roles',
  marketing: 'Marketing / Brand / Performance Marketing',
  operations: 'Operations / Supply Chain / Strategy',
  founder: 'Startup Founder / Entrepreneur',
  tech: 'Engineering / DevOps / Tech Roles'
};